__turbopack_context__.v({
  "close": "TypePropRef-module__Et2zIa__close",
  "description": "TypePropRef-module__Et2zIa__description",
  "header": "TypePropRef-module__Et2zIa__header",
  "headerLink": "TypePropRef-module__Et2zIa__headerLink",
  "label": "TypePropRef-module__Et2zIa__label",
  "link": "TypePropRef-module__Et2zIa__link",
  "popup": "TypePropRef-module__Et2zIa__popup",
  "propList": "TypePropRef-module__Et2zIa__propList",
  "propRow": "TypePropRef-module__Et2zIa__propRow",
  "trigger": "TypePropRef-module__Et2zIa__trigger",
  "value": "TypePropRef-module__Et2zIa__value",
});
